module.exports = '[0-9]*'



//////////////////
// WEBPACK FOOTER
// ../~/numeric-pattern/index.js
// module id = 1631
// module chunks = 1